import './CommonPopup.css';
import { useTranslation } from 'react-i18next';

export default function CommonPopup({ isOpen, message, onConfirm, onCancel }) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <p className="popup-message">{message}</p>
        <div className="popup-buttons">
          {onCancel && (
            <button className="popup-btn popup-btn-cancel" onClick={onCancel}>
              {t('common.no')}
            </button>
          )}
          <button className="popup-btn popup-btn-confirm" onClick={onConfirm}>
            {onCancel ? t('common.yes') : t('common.ok', '확인')}
          </button>
        </div>
      </div>
    </div>
  );
}
